var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n    Add a fee of "+_vm._s(_vm._f("number")(_vm.amount,{minimumFractionDigits: 2}))+" to the customer's next invoice.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }